import { TKey } from "@/app/translations/TKey";
import { HomePricingPeriod, HomePricingPeriodTab } from "@/app/types/home/HomePricing";

export const HOME_PRICING_PERIODS: HomePricingPeriodTab[] = [
  { period: HomePricingPeriod.MONTHLY, labelKey: TKey.HOME_MEIDLY_PRICING_PERIOD_MONTHLY },
  { period: HomePricingPeriod.ANNUAL, labelKey: TKey.HOME_MEIDLY_PRICING_PERIOD_ANNUAL },
];

export const HOME_PRICING_PRO_FEATURES: TKey[] = [
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_RECORDING,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_CALLS,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_PATTERNS,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_AVATAR,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_PROSPECTS,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_SCAN,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_SEQUENCES,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_INTEGRATIONS,
  TKey.HOME_MEIDLY_PRICING_PRO_FEATURE_SUPPORT,
];

export const HOME_PRICING_CUSTOM_FEATURES: TKey[] = [
  TKey.HOME_MEIDLY_PRICING_CUSTOM_FEATURE_EVERYTHING,
  TKey.HOME_MEIDLY_PRICING_CUSTOM_FEATURE_POOLED,
  TKey.HOME_MEIDLY_PRICING_CUSTOM_FEATURE_SEATS,
  TKey.HOME_MEIDLY_PRICING_CUSTOM_FEATURE_BRAND,
  TKey.HOME_MEIDLY_PRICING_CUSTOM_FEATURE_INTEGRATIONS,
  TKey.HOME_MEIDLY_PRICING_CUSTOM_FEATURE_RIGHTS,
  TKey.HOME_MEIDLY_PRICING_CUSTOM_FEATURE_SUPPORT,
];
